import { Pill } from '../crop-circle/Components/Pill';

interface Category {
  id: string;
  name: string;
}

interface CategoryBadgeProps {
  category: Category;
  count?: number;
  onCategorySelect?: (categoryId: string) => void;
  isSelected?: boolean;
}

export const CategoryBadge = ({
  category,
  onCategorySelect,
  isSelected = false,
}: CategoryBadgeProps) => {
  const handlePress = () => {
    if (onCategorySelect) {
      onCategorySelect(category.id);
    }
  };

  return (
    <Pill
      key={`category-badge-${category.id}`}
      label={`${category.name}`}
      onPress={handlePress}
      selected={isSelected}
      showIcon={false}
    />
  );
};
